import isStreamVideo from '@anm/helpers/is/isStreamVideo';
import useDownloadStreamVideo from '@anm/hooks/useDownloadStreamVideo';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { hostedVideoSelectors } from '../../../../store/modules/hostedVideo';
import { streamActions, streamSelectors } from '../../../../store/modules/stream';
import { useDownloadFileUrl } from '../../../hosting/DownloadVideo/DownloadDropdown/hooks';

type DownloadProps = {
  title: string;
  hostId?: string;
  streamId?: string | null;
};

const useDownloadVideoHandler = ({ title, hostId, streamId }: DownloadProps) => {
  const dispatch = useDispatch();
  const stream = useSelector(streamSelectors.selectStream);
  const manifest = useSelector(hostedVideoSelectors.selectManifest);

  const fetchStream = () => streamId && dispatch(streamActions.fetchStream(streamId));
  const clearStreamState = () => dispatch(streamActions.clearStream());

  const handelDownloadStream = useDownloadStreamVideo(stream?.meta.uploadId);
  const originalFile = manifest?.main.find(f => f.isOriginal);
  const videoUrl = useDownloadFileUrl(originalFile, title).url;

  const handelDownloadVideo = () => {
    if (!manifest || manifest.id !== hostId || !videoUrl) return;

    console.log('DDD ', title, videoUrl);

    window.open(videoUrl, '_blank');
  };

  useEffect(() => {
    if (!stream || stream.streamId !== streamId) return;

    handelDownloadStream();

    return () => {
      stream?.streamId === streamId && clearStreamState();
    };
  }, [stream]);

  const manifestFiles = manifest?.main || [];
  const isStream = manifestFiles.some(f => isStreamVideo(f.path));

  const downloadHandler = isStream ? fetchStream : handelDownloadVideo;

  return downloadHandler;
};

export default useDownloadVideoHandler;
